import { render, staticRenderFns } from "./ContactCenter.vue?vue&type=template&id=42a09760&scoped=true"
import script from "./ContactCenter.vue?vue&type=script&lang=js"
export * from "./ContactCenter.vue?vue&type=script&lang=js"
import style0 from "./ContactCenter.vue?vue&type=style&index=0&id=42a09760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a09760",
  null
  
)

export default component.exports